import { useTranslation } from "react-i18next";
import { DoraButton } from "dora-shared/frontend";
import React, { useState } from "react";
import { useAppDispatch } from "../../redux-store";
import Paper from "@mui/material/Paper";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Popper from "@mui/material/Popper";
import { addRoute, archiveRoute } from "../../ducks/routes";

const LiteVersionArchiveRouteButton = ({ routeId }: { routeId: string }) => {
  const { t } = useTranslation(["dispatching", "components"]);
  const dispatch = useAppDispatch();
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);

  const onArchiveConfirm = () => {
    setRequestInProgress(true);
    dispatch(archiveRoute({ id: routeId }))
      .unwrap()
      .then(() => {
        dispatch(addRoute({ intendedStartDate: null }))
          .unwrap()
          .then(() => {
            setRequestInProgress(false);
            setAnchorEl(null);
          })
          .catch(() => {
            setRequestInProgress(false);
            setAnchorEl(null);
          });
      })
      .catch(() => {
        setRequestInProgress(false);
      });
  };

  return (
    <>
      <div className="flex justify-end">
        <DoraButton
          variant="primary-filled"
          onClick={handleClick}
          disabled={requestInProgress}
        >
          {t("liteVersion.saveRouteAndClose")}
        </DoraButton>
      </div>
      <Popper open={open} anchorEl={anchorEl}>
        <Paper>
          <DialogTitle> {t("openRouteView.endRoute")}</DialogTitle>
          <DialogContent>{t("openRouteView.youAreEndingARoute")}</DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleClick}
              disabled={requestInProgress}
            >
              {t("components:buttonLabels.cancel")}
            </Button>
            <Button
              variant="contained"
              onClick={onArchiveConfirm}
              disabled={requestInProgress}
            >
              {t("components:buttonLabels.confirm")}
            </Button>
          </DialogActions>
        </Paper>
      </Popper>
    </>
  );
};

export default LiteVersionArchiveRouteButton;
